import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { AtsDate, AtsDateUnit } from '@ats/utility';

@Pipe({
    name: 'cmTime',
    standalone: false
})
export class CmTimePipe implements PipeTransform {
	constructor() {}

	transform(value: any, format: string = 'h:mm:ss a', duration = false, unit?: string | AtsDateUnit): string {
		if (typeof value === 'string' && value !== '') {
			value = new Date(value);
		}
		// We're using this method to tell if an object is a date because it is the most efficient (yay js!) while being perfectly accurate.
		// See the comment dated May 26 2017 here: https://stackoverflow.com/questions/643782/how-to-check-whether-an-object-is-a-date
		const num = parseInt(value);
		if (!value || Object.prototype.toString.call(value) !== '[object Date]' || value === null) {
			if (isNaN(num)) {
				return value ? value.toString() : '';
			} else if (!duration) {
				value = new Date(num);
			}
		}
		if (duration && (num || num === 0)) {
			let typedUnit: AtsDateUnit;
			if (unit) {
				if (typeof unit === 'string') {
					const char = unit.charAt(0);
					const rest = unit.substring(1);
					typedUnit = AtsDateUnit[char.toUpperCase() + rest];
				} else {
					typedUnit = unit;
				}
			}

			return AtsDate.formatDuration(num, typedUnit);
		} else {
			return formatDate(value, format, 'en');
		}
	}
}
